import { Button } from 'primereact/button';
import { Checkbox } from "primereact/checkbox";
import service from './services/service';
import React, { useCallback, useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import TableDataList from './TableDataList';
import TableManagement from './TableManagement';
//Bu komponent müşterinin aktif tablosundan veya hangi tablodan istenirse haritada gösterme kapatma ve bilgi almak için yapılmıştır

//props olarak tablo ve kolonlar gönderilmektedir.Table crud üzerinde eğer bu component yönetim panlinde değilde haritada işlem yapmak için kullanılcaksa table crud üzerinden
//otomatik burası çağrılır isMap parametresi true gönderilirse
export const TableMapInfoManagement = (props) => {

    const [isShowMap, setShowMap] = useState(false);
    const [mapTool, setMapTool] = useState(null);
    const [selectedLayerName, setLayerName] = useState(null);
    const [infoResults, setInfoResults] = useState([]);
    const [isShowActiveTable, setIsShowActiveTable] = useState(false);
    const [isShowTableManagement, setIsShowTableManagement] = useState(false);
    let layerNameTemp = "";
    useEffect(() => {
        window.layerControlTokenKey = props.tokenKey;
        if (mapTool === null && props.mapTool) {
            setMapTool(props.mapTool);
        }
        else
            console.log("mapTool referansı gereklidir.");
    }, {})
    //Aktif tablonun veya sorgulanan tabloyu wms katmanı olarak haritaya eklemek için oluşturulan
    //katmandır Her tablo için benzersiz oluşturulur.

    const createLayerName = () => {
        return props.layerName + "-proxy" + props.table.name;
    }
    const showWmsLayer = (isShow) => {

        let layerName = props.layerName + "-proxy" + props.table.name;
        if (mapTool.findLayer(layerName) != null) {

            props.mapTool.getMap().removeLayer(mapTool.findLayer(layerName));
        }
        if (!isShow) {

            if (mapTool.getInteraction("info_interaction" + layerName)) {
                setActiveInteaction(false);
            }
            return;
        }
        setLayerName(layerName);
        layerNameTemp = layerName;
        //Geoservere istek atılırken zorunlu parametre listesi hangi layer'a istek atılcak 
        //layerın şeffaflığı ne olcak ve filitre vermek istersek burda göndereceğiz
        let currentLayers = [{ key: props.table.name, opacity: 100, cqlFilter: "1=1" }];
        let params = {
            layers: currentLayers.map(x => x.key),//İstek atılcak layer listesi
            opacities: currentLayers.map(x => x.opacity), //layerların şeffaflığı
            cqlFilters: currentLayers.map(x => x.cqlFilter) //filitre
        }

        //Harita üzerinde kullanmak amacıyla layer oluşturulur
        const wmsLayer = props.MapTool.createTileLayer({
            name: layerName,
            source: props.MapTool.createTileLayerSourceWithHeaders({
                urls: [props.apiUrl + "/DynamicLayer/GetMap"],
                params: params,
            }),
        });
        //Haritaya eklenir
        props.mapTool.addLayer(wmsLayer);


        //Bilgi almak amacıyla point tipince bir interaction oluşturulur ve bir layer

        const vectorlayer = props.MapTool.createVectorLayer({
            name: layerName + "_vector",
            source: props.MapTool.createVectorLayerSource({})
        });
        mapTool.addLayer(vectorlayer);

        const infoInteraction = mapTool.createDrawInteraction(
            "info_interaction" + layerName,
            (layerName + "_vector"),
            "Point");

        //Kullanıcı haritaya tıkladığında "getFeatureInfo" methoduna tıklanılan noktada oluşan obje gönderilir
        infoInteraction.on("drawend", getFeatureInfo);
        //Interaction yoksa ekle
        if (!mapTool.getInteraction("info_interaction" + layerName)) {
            mapTool.addInteraction(infoInteraction);
        }
    }
    const setActiveInteaction = (status) => {
        //Oluşturulan interactionun açılma ve kapanmasını sağlar layertemp drawend methodunda this refereansını kaybettii için layername
        //layerNameTemp değişkenine eşitlenmiştir.

        let interaction = props.mapTool.getMap()
            .getInteractions()
            .getArray()
            .find((x) => x.get("name") === "info_interaction" + createLayerName());

        if (interaction) {
            interaction.setActive(status);
        }

    };
    const getFeatureInfo = (options) => {
        //İlgili tıklanılan nokta featureinfo servisine gönderilir ve ilgili katman bilgisi çekilir
        const coordinates = options.feature.getGeometry().getCoordinates();
        let url = mapTool.getLayerSource(layerNameTemp).
            getFeatureInfoUrl(coordinates,
                mapTool.getResolution(),
                mapTool.getProjection(),
                {
                    'INFO_FORMAT': 'application/json'
                });

        if (url) {
            //Burada  leyarin source urlsi getmap olduğu için bunu bilgi al için yazılan getfetureinfo adı ile değiştirip ilgili methoda gitmesini sağlıyoruz
            url = url.replaceAll("GetMap", "GetFeatureInfo");
            url += "&QUERY_LAYERS=" + props.table.name
        }
        service.get(url).then(response => {

            props.mapTool.clearLayersByName([createLayerName() + "_vector"]);

            if (!response.success) {
                console.log("Veri bulunamadı");
            }
            let data = JSON.parse(response.data);
            let dataTable = [];
            if (data.features && data.features.length > 0) {

                for (var i = 0; i < data.features.length; i++) {

                    dataTable.push(data.features[i]["properties"]);
                }

            }
            setActiveInteaction(false);
            setInfoResults(dataTable);
        }).catch(e => {
            console.log(e);
        });
    }

    return (<div id={props.customerTableInfoId} className="">
        <h3>{props.title}</h3>
        {/*Bilgi Al aracı aktif olduktan sonrra sonuçların bir dialog penceresinde görüntülenmesi*/}
        <Dialog position='bottom' header="Bilgi Al" modal={false} visible={infoResults.length > 0}
            onHide={() => { setInfoResults([]) }} style={{ width: '40vw' }}>
            <DataTable value={infoResults} tableStyle={{ minWidth: '50rem' }}>
                {props.columns.filter(x => x.type !== "Geometry").map(x => <Column field={x.name} header={x.name}></Column>)}
            </DataTable>
        </Dialog>
        {props.isShowActiveTable  &&

            <Dialog maximizable position='bottom' header="Aktif Müşteri Tablosu Sorgula" modal={false}
                visible={isShowActiveTable}
                onHide={() => setIsShowActiveTable(false)}
                style={{ width: '80vw' }}>
                <TableDataList
                    {...props}            
                    isActiveTable={true}
                    isEdit={false}
                    layerName={props.layerName}
                    isPopup={props.isPopup}
                    
                />

            </Dialog>
        }
        {isShowTableManagement &&

            <Dialog maximizable position='bottom' header="Tablo Yönetimi" modal={false}
                visible={isShowTableManagement}
                onHide={() => setIsShowTableManagement(false)}
                style={{ width: '80vw' }}>
                <TableManagement
                    apiUrl={props.apiUrl}
                    id="dynamic-table-creator"
                    isTableList={true}
                    isEdit={true}
                    tokenKey={props.tokenKey}
                    tableType={props.tableType}


                />
            </Dialog>
        }

        <div id="button-group-customer-management">
            <Button type="button" icon="pi pi-map" label="Müşteri Sorgula" outlined onClick={() => {
                if (props.isShowActiveTable) {
                    setIsShowActiveTable(true);
                }
                if (props.onShowTable) {
                    //onShowTable null gönderilmezse  verilerin tablo üzerinde gösterilmesi sağlanır
                    props.onShowTable();
                }
            }} />

            <Button disabled={!isShowMap} type="button" icon="pi pi-info" label="Bilgi Al" outlined onClick={() => {
                //Bilgi alı aktif et
                setActiveInteaction(true);
            }} />


            <Button  type="button" icon="pi pi-info" label="Tablo Yönetimi " outlined onClick={() => {
                //Tablo Yöneticisini aç
                setIsShowTableManagement(true);
            }} />
        </div>

        <Checkbox inputId="ingredient1" name="pizza" value="Cheese" checked={isShowMap} onChange={(e) => {
            //Checked true ise hariiada gösterime başlar false olduğunda haritada gösterimi durdurur
            showWmsLayer(e.checked);
            setShowMap(e.checked);
            setActiveInteaction(false);

        }} />
        <label htmlFor="ingredient1" className="ml-2">Müşterileri Göster</label>

    </div>)
}

export default TableMapInfoManagement;